module.exports = __webpack_public_path__ + "static/media/Turtonator_gaussian2.1778520f.png";